<template>
  <el-table-column
    prop="shop_visits"
    label="Látogatások"
    min-width="130"
  >
    <template slot-scope="scope">
      <div v-if="scope.row.id">
        Összesen: {{ scope.row.shop_visits.length }} látogatás
        <el-tag
          v-if="scope.row.shop_visits.length && scope.row.shop_visits[0].exit"
          size="mini"
          type="info"
        >
          Utolsó látogatás: {{ scope.row.shop_visits[0].exit | date }}
        </el-tag>
      </div>
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'shop_visits',
  };
</script>
